import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCsrfToken } from '../../utils/csrf';

export function useLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    setIsSuccess(false);

    try {
      const csrfToken = await getCsrfToken();
      
      const response = await fetch('/api/login/', {
        method: 'POST',
        body: JSON.stringify({ email, password }),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': csrfToken,
        },
      });
    
      const data = await response.json();
      
      if (response.ok) {
        localStorage.setItem('isAuthenticated', 'true');
        setIsSuccess(true);
        // Wait 1 second before redirecting
        await new Promise(resolve => setTimeout(resolve, 1000));
        navigate('/home');
      } else {
        setError(data.error || 'Login failed. Please try again.');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Network error. Please check your connection and try again.');
    } finally {
      if (!isSuccess) {
        setIsLoading(false);
      }
    }
  };

  return {
    email,
    password,
    error,
    showPassword,
    isLoading,
    isSuccess,
    setEmail,
    setPassword,
    setShowPassword,
    handleSubmit
  };
}